import React, { useEffect, useRef } from 'react'
import { Calculator } from './styled-components'

export const ScientificDesmosCalculator = ({ config }) => {
  const desmosScientificRef = useRef()

  useEffect(() => {
    const Desmos = window.Desmos
    if (desmosScientificRef.current && Desmos) {
      const desmosScientificCalculator = Desmos.ScientificCalculator(
        desmosScientificRef.current,
        config
      )

      return () => {
        desmosScientificCalculator.destroy()
      }
    }
  }, [config])

  return (
    <Calculator id="demos-scientific-calculator" ref={desmosScientificRef} />
  )
}
